export default __webpack_public_path__ + "static/media/tr_3.6065eb42.mp3";